/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NamingAnswerInput = {
  slot: string;
  value: string;
};

export type BuildProductNameQueryVariables = Exact<{
  subFamily: string;
  answers: Array<Types.NamingAnswerInput> | Types.NamingAnswerInput;
}>;


export type BuildProductNameQuery = { buildProductName: { name: string } };


export const BuildProductNameDocument = /*#__PURE__*/ gql`
    query BuildProductName($subFamily: String!, $answers: [NamingAnswerInput!]!) {
  buildProductName(subFamily: $subFamily, answers: $answers) {
    name
  }
}
    `;

/**
 * __useBuildProductNameQuery__
 *
 * To run a query within a React component, call `useBuildProductNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildProductNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildProductNameQuery({
 *   variables: {
 *      subFamily: // value for 'subFamily'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useBuildProductNameQuery(baseOptions: Apollo.QueryHookOptions<BuildProductNameQuery, BuildProductNameQueryVariables> & ({ variables: BuildProductNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildProductNameQuery, BuildProductNameQueryVariables>(BuildProductNameDocument, options);
      }
export function useBuildProductNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildProductNameQuery, BuildProductNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildProductNameQuery, BuildProductNameQueryVariables>(BuildProductNameDocument, options);
        }
// @ts-ignore
export function useBuildProductNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BuildProductNameQuery, BuildProductNameQueryVariables>): Apollo.UseSuspenseQueryResult<BuildProductNameQuery, BuildProductNameQueryVariables>;
export function useBuildProductNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BuildProductNameQuery, BuildProductNameQueryVariables>): Apollo.UseSuspenseQueryResult<BuildProductNameQuery | undefined, BuildProductNameQueryVariables>;
export function useBuildProductNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BuildProductNameQuery, BuildProductNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuildProductNameQuery, BuildProductNameQueryVariables>(BuildProductNameDocument, options);
        }
export type BuildProductNameQueryHookResult = ReturnType<typeof useBuildProductNameQuery>;
export type BuildProductNameLazyQueryHookResult = ReturnType<typeof useBuildProductNameLazyQuery>;
export type BuildProductNameSuspenseQueryHookResult = ReturnType<typeof useBuildProductNameSuspenseQuery>;
export type BuildProductNameQueryResult = Apollo.QueryResult<BuildProductNameQuery, BuildProductNameQueryVariables>;